import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'

const selectStructureState = (state: RootState) => state?.structures

export const selectNormalizedStructure = createSelector(selectStructureState, (state) => ({
    structure: state.normalizedStructure,
    list: state.normalizedIds,
}))
